import { render, staticRenderFns } from "./GeneralOptions.vue?vue&type=template&id=40fb55fc&"
import script from "./GeneralOptions.vue?vue&type=script&lang=js&"
export * from "./GeneralOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports